import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button'
import { TextField } from 'rmwc/TextField'
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography'
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class AdminUpdateCurrencyExchageRate extends Component {

	constructor(props){
		super(props)
		this.state = {
			errorMsg: '',
			data: {
				id: '',
				currencyName: '',
				value: '',
			},
			componentState: {
				saveDisabled: false,
			}
		}
	}

	componentDidMount(){
		let data = Object.assign({}, this.state.data)
		let componentState = Object.assign({}, this.state.data)
		let errorMsg
		let url = 'admin/fetch/currency/exchange/rate'

		api.getResponse(this.props.user.accessToken, url)
		.then((result)=>{
			if(result.status === 'success'){
				data.id = result.data.id
				data.currencyName = result.data.name
				data.value = result.data.value
				this.setState({data: data})
			}
			else if (result.status === 'error') {
				errorMsg = result.message
				componentState.saveDisabled = true
				this.setState({componentState: componentState, errorMsg: errorMsg})
			}
		})
		.catch((err) => {
       this.setState({ errorMsg: 'Error in Fetching Details'});
    })
	}

	onInputChange = (evt) => {
		let data = Object.assign({}, this.state.data)
		data[evt.target.name] = evt.target.value
		this.setState({data: data})
	}

	handleExchangeRateChange = (evt) => {
		evt.preventDefault()

		if((this.state.data.currencyName === '') || (this.state.data.value === '')){
			this.setState({errorMsg: 'Exchange Rate cannot be empty'})
		}

		else{
			let componentState = Object.assign({}, this.state.componentState)
			let url = `admin/update/currency/exchange/rate/${this.state.data.id}`
			let errorMsg = ''
			let values = {
			name:  this.state.data.currencyName,
      conversion_rate: parseFloat(this.state.data.value)
    	}
			api.putValuesApi(this.props.user.accessToken, url, values)
			.then((result)=> {
				if(result.status === 'success'){
					errorMsg = result.message
					componentState.saveDisabled = true
					this.setState({errorMsg: errorMsg, componentState: componentState})
				}
				else if(result.status === 'error'){
					errorMsg = result.message
					this.setState({errorMsg: errorMsg})
				}
			})
			.catch((err) => {
       this.setState({ errorMsg: 'Error in updating the currency exchange rate'});
    	})
		}
	}

	render(){
		return(
			<div> 
				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}} >
							<Typography use="headline6"> Currency Exchange Rate Convertor</Typography>
							<br/>
							<GridCell span="12">
								<Typography use ='body2'>Please enter the US exchange rate for INR in the below text box: </Typography>
							</GridCell>

							<GridCell span ="2">
								<TextField outlined  className= 'text_input' autoComplete="off" label= 'Dollar Exchange Rate' name= 'value' onChange={this.onInputChange} value={this.state.data.value} disabled={this.state.componentState.saveDisabled}/>
							</GridCell>
							<GridCell span="10"/>

							<GridCell span="12">
								<Typography use ='body2'>1 Indian Rupee is equal to {this.state.data.value} US dollars.</Typography>
							</GridCell>
							<br/>

							<GridCell span ="10">
								<Button raised onClick={this.handleExchangeRateChange} disabled = {this.state.componentState.saveDisabled}>Update</Button>
							</GridCell>
							<GridCell span ="2"/>

							<GridCell span="12">
								<br/>
								<StatusMessage error_msg = {this.state.errorMsg}/>
							</GridCell>
						</Card>
					</GridCell>
				</Grid>
			</div>
			)
	}

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdateCurrencyExchageRate);


// WEBPACK FOOTER //
// ./src/views/admin/AdminUpdateCurrencyExchangeRate.jsx